var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6806 7.94118H16.3194C15.5907 7.94118 15 8.39153 15 8.94706V9.05294C15 9.60848 15.5907 10.0588 16.3194 10.0588H23.6806C24.4093 10.0588 25 9.60848 25 9.05294V8.94706C25 8.39153 24.4093 7.94118 23.6806 7.94118Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6806 15.8824H8.31944C7.59074 15.8824 7 16.3327 7 16.8882V16.9941C7 17.5497 7.59074 18 8.31944 18H23.6806C24.4093 18 25 17.5497 25 16.9941V16.8882C25 16.3327 24.4093 15.8824 23.6806 15.8824Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6806 0H1.31944C0.590735 0 0 0.450349 0 1.00588V1.11176C0 1.6673 0.590735 2.11765 1.31944 2.11765H23.6806C24.4093 2.11765 25 1.6673 25 1.11176V1.00588C25 0.450349 24.4093 0 23.6806 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBar);
export default __webpack_public_path__ + "static/media/menuBar.be3cbc1592972743e74e81831a8c478a.svg";
export { ForwardRef as ReactComponent };